import * as React from "react";

export type CardProps = React.HTMLAttributes<HTMLDivElement>;

export function Card({ className, ...props }: CardProps) {
  return (
    <div
      className={["rounded-xl border border-gray-100 bg-white shadow-sm", className]
        .filter(Boolean)
        .join(" ")}
      {...props}
    />
  );
}
